import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
function getLabel(control, locale) {
    if (!control || !control.options) {
        return "";
    }
    let name = control.options.name;
    const name_i18n = control.options.name_i18n;
    if (name_i18n) {
        // const map = JSON.parse(name_i18n);
        const map = name_i18n;
        if (map[locale]) {
            name = map[locale];
        }
    }
    return name;
}
let Logic = class Logic extends Vue {
    render(h) {
        const locale = this.$i18n ? this.$i18n.locale : '';
        return h("h3", `${getLabel(this.control, locale)}`);
    }
};
tslib_1.__decorate([
    Prop({ default: {} })
], Logic.prototype, "control", void 0);
Logic = tslib_1.__decorate([
    Component({ name: 'Logic' })
], Logic);
export default Logic;
